export function PortalPage() {
  return (
    <main className="portal-shell">
      <section className="portal-intro">
        <span className="eyebrow">Asterum Private Network</span>
        <h1>Como você quer acompanhar o ASTER?</h1>
        <p>Revise a tese completa ou entre no painel com os dados realizados da empresa.</p>
      </section>

      <section className="portal-options" aria-label="Escolha uma área do ASTER">
        <a className="portal-option presentation-option" href="/apresentacao">
          <span className="portal-option-media">
            <img src="/portal/apresentacao-preview.png" alt="Capa da apresentação de investimento ASTER" />
          </span>
          <span className="portal-option-copy">
            <small>Apresentação</small>
            <strong>Entenda a tese de investimento.</strong>
            <span>Veja a proposta, os comparativos com altcoins, a fórmula e os cenários de retorno.</span>
            <b>Abrir apresentação</b>
          </span>
        </a>

        <a className="portal-option dashboard-option" href="/painel">
          <span className="portal-option-media">
            <img src="/portal/painel-preview.png" alt="Prévia do painel de performance do ASTER" />
          </span>
          <span className="portal-option-copy">
            <small>Painel do investidor</small>
            <strong>Acompanhe o que já aconteceu.</strong>
            <span>Consulte preço, carteira, resultados realizados, caixa e histórico de fechamentos.</span>
            <b>Entrar no painel</b>
          </span>
        </a>
      </section>

      <p className="portal-footnote">As duas áreas usam a mesma sessão privada.</p>
    </main>
  );
}
